import React from 'react';
import { Outlet } from 'react-router-dom';
import { NavigationBar } from '../component/NavigationBar/NavigationBar';
// import { useState } from 'react';
import Sidebar from '../component/SideBar/SideBar';

const Layout: React.FunctionComponent = () => {
  // const [open, setOpen] = useState(false);
  return (
    <>
      <div className="admin">
        <Sidebar />
        <main className="main">
          <NavigationBar />
          <Outlet />
        </main>
      </div>
    </>
  );
};

export { Layout };
